import * as React from "react";
import { ScrollView, View } from "react-native";
import { useDispatch } from "react-redux";
import toast from "@utils/toast";
import Button from "./FormButton";
import Images from "./Images";
import TextArea from "./TextArea";
import TextInput from "./TextInput";
import debounce from "../../utils/debounce";
import TextDisabled from "./TextDisabled";
import TextAreaNumber from "./TextAreaNumer";
import t from "@constants/localization";

const PATH = "screens/SupportTree/components/Form";

const componentByType = {
  input: TextInput,
  textarea: TextArea,
  voice: () => null,
  images: Images,
  submit: Button,
  button: Button,
  button_link: Button,
  plain_text: TextDisabled,
  textarea_number: TextAreaNumber,
};

const formHasValue = (data) => {
  return Object.keys(data).some((key) => {
    const value = data[key];
    if (data.inputType === "textarea_number") {
      if (key !== "inputType" && value.length === 10) {
        return true;
      }
    } else {
      if (
        typeof value === "number" ||
        (value &&
          typeof value === "string" &&
          value.trim() !== "" &&
          key !== "inputType")
      )
        return true;
    }
  });
};

const FormRenderer = ({ children: formItems, onSubmit }) => {
  const dispatch = useDispatch();
  const [data, setData] = React.useState({});
  const setFormData = (key, value, inputType) => {
    let text = value;
    if (inputType === "textarea_number") {
      text = text.replace(/[^0-9]/g, "");
    }
    setData({ ...data, [key]: text, inputType: inputType });
  };
  let isSubmitFound = false;

  let handleOnSubmit = () => {
    if (!formHasValue(data)) {
      toast.showShortToast("कृपया फॉर्म भरें");
    } else {
      onSubmit(data);
    }
  };

  let debounceOnSubmit = debounce(handleOnSubmit, 1000);

  return (
    <>
      <ScrollView
        style={{
          paddingVertical: 10,
          paddingHorizontal: 25,
        }}
        contentContainerStyle={{ flexGrow: 1 }}
      >
        {formItems.map((formItem) => {
          let _onSubmit = setFormData;
          const Component = componentByType[formItem.inputType];
          if (
            formItem.inputType === "submit" ||
            formItem.inputType === "button" ||
            formItem.inputType === "button_link" ||
            formItem.dataKey === "faq1"
          ) {
            _onSubmit = () => {
              onSubmit(data);
            };
            isSubmitFound = true;
          }
          return Component ? (
            <View style={{ marginVertical: 10 }}>
              <Component
                key={formItem.dataKey}
                formItem={formItem}
                onSubmit={(data) =>
                  _onSubmit(formItem.dataKey, data, formItem.inputType)
                }
                value={data[formItem.dataKey]}
              />
            </View>
          ) : null;
        })}
      </ScrollView>
      {!isSubmitFound && (
        <View
          style={{
            justifyContent: "flex-end",
            margin: 10,
          }}
        >
          <Button
            key={-123}
            formItem={{ label: t(`${PATH}/submit`), type: "submit" }}
            onSubmit={debounceOnSubmit}
            value={"submit"}
            disabled={!formHasValue(data)}
          />
        </View>
      )}
    </>
  );
};

export default FormRenderer;
